import React, { useEffect, useState, useContext } from "react";
import styles from "./EditUserModal.module.css";
import { UserContext } from '../../../context/UserContext';
import { FaChevronDown } from "react-icons/fa";
import { formatPhone } from "../../../utils/PhoneUtils";
import { formatCPF } from "../../../utils/FormatUtils";
import { editUserFromDatabase } from "../../../hooks/User";
import { getStoresFromDatabase } from "../../../hooks/Store";
import { handleUserRole } from "../../../utils/UserRole";
import { GetStoreIds } from '../../../utils/GetStoreIds';

function Modal({ closeModal }) {
  const { selectedUser, editUser } = useContext(UserContext);
  const [name, setName] = useState(selectedUser?.name || "");
  const [role, setRole] = useState(selectedUser?.role || "");
  const [selectedUserRole, setSelectedUserRole] = useState(selectedUser != null ? handleUserRole(selectedUser?.role) : "Selecione a função do usuário");
  const [username, setUsername] = useState(formatCPF(selectedUser?.username) || selectedUser?.username || "");
  const [password, setPassword] = useState("***********");
  const [phone, setPhone] = useState(selectedUser?.phone || "");
  const [access, setAccess] = useState(selectedUser?.access || "");
  const [storeIds, setStoreIds] = useState([]);
  const [stores, setStores] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState("");
  const [isUserRoleDropdownOpen, setIsUserRoleDropdownOpen] = useState(false);
  const [isStoreDropdownOpen, setIsStoreDropdownOpen] = useState(false);
  const toggleUserRoleDropdown = () => { setIsUserRoleDropdownOpen(!isUserRoleDropdownOpen) };
  const toggleStoreDropdown = () => { setIsStoreDropdownOpen(!isStoreDropdownOpen) };

  useEffect(() => {
    if(selectedUser?.role === "MANAGER") {
      setIsStoreDropdownOpen(true)
    }else {
      setIsStoreDropdownOpen(false)
    }
    if(selectedUser?.stores?.length === 0) {
        setSelectedStore("Selecione a loja")
    }else if(selectedUser?.stores?.length === 1) {
      setSelectedStore(selectedUser.stores[0].name)
  }
  },[])

  const handleUserRoleSelect = (role) => {
    setSelectedUserRole(role);
    switch (role) {
      case "Master/Admin":
        setRole("MASTER");
        setAccess("PANEL_ADMIN_ACCESS");
        break;
      case "Gerente":
        setRole("MANAGER");
        setAccess("PANEL_ADMIN_ACCESS");
        break;
      case "Usuário de App":
        setRole("APP_USER");
        setAccess("APP_ACCESS");
        break;
      case "Usuário de Painel":
        setRole("PANEL_USER");
        setAccess("PANEL_ACCESS");
        break;
      default:
        setRole("");
        break;
    }
  };

  const handleToggleStoreSelection = (store) => {
    setSelectedStores((prevSelectedStores) => {
      if (prevSelectedStores.some((s) => s.id === store.id)) {
        return prevSelectedStores.filter((s) => s.id !== store.id);
      } else {
        return [...prevSelectedStores, store];
      }
    });
  };

  const handleSelectStore = ( store ) => {
    setSelectedStore(store.name);
    setStoreIds([store.id]);
  };

  useEffect(() => {
    const fetchStores = async () => {
      const storeData = await getStoresFromDatabase();
      if (storeData) {
        setStores(storeData.data.stores);

        if (selectedUser?.stores?.length > 0) {
          const storesFromApi = storeData.data.stores;
          const selectedStoreIds = selectedUser.stores.map(store => store.id);
          
          const storesToPreselect = storesFromApi.filter(store => selectedStoreIds.includes(store.id));
          setSelectedStores(storesToPreselect);
        }
      }
    };
    fetchStores();
  }, []);

  useEffect(() => {
    setStoreIds(GetStoreIds(selectedStores));
  }, [selectedStores]);

  const handlePhoneChange = (e) => {
    const rawValue = e.target.value;
    const formattedPhone = formatPhone(rawValue);
    setPhone(formattedPhone);
  };

  const handleEditUser = async () => {
    const userData = {
      id: selectedUser.id,
      name,
      username: username.replace(/\D/g, ''),
      password,
      phone,
      role,
      access,
      storeIds
    };

    const response = await editUserFromDatabase(userData);
    if (response) {
      editUser(true);
      closeModal();
    } else {
      editUser(false);
    }
  };

  const renderStoresDropdown = () => {
    if (role === "MANAGER" || selectedUser?.role === "MANAGER") {
      return (
        <>
          <button
            type="button"
            onClick={ toggleStoreDropdown }
            className={styles.dropdownButton}>
              Selecione uma ou mais lojas
            <FaChevronDown className={styles.icon} />
          </button>
        </>
      );

    } else {
      return (
        <>
          <button
            type="button"
            onClick={toggleStoreDropdown}
            className={styles.dropdownButton}>

            { selectedStore !== null ? selectedStore :  "Selecione a loja" }
            <FaChevronDown className={styles.icon} />

          </button>
        </>
      );
    }
  };
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <form>
            <label>
              <span>Nome</span>
              <input
                type="text"
                required
                placeholder="Digite o nome do usuário"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </label>

            <label>
              <span>CPF</span>
              <input
                type="text"
                required
                placeholder="Digite o CPF do usuário"
                value={username}
                onChange={(e) => setUsername(formatCPF(e.target.value))}
              />
            </label>

            <label>
              <span>Senha</span>
              <input
                type="password"
                required
                placeholder="Digite a senha do usuário"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>

            <label>
              <span>Telefone</span>
              <input
                type="text"
                required
                placeholder="Digite o telefone do usuário"
                value={phone}
                onChange={handlePhoneChange}
              />
            </label>

            <label>
              <span>Função do Usuário</span>
              <div className={styles.dropdown}>
                <button type="button" onClick={ toggleUserRoleDropdown } className={styles.dropdownButton}>
                  { selectedUserRole } <FaChevronDown className={styles.icon} />
                </button>

                {isUserRoleDropdownOpen && (
                  <div className={styles.dropdownContent}>
                    <div onClick={() => handleUserRoleSelect("Master/Admin")}>Master/Admin</div>
                    <div onClick={() => handleUserRoleSelect("Gerente")}>Gerente</div>
                    <div onClick={() => handleUserRoleSelect("Usuário de App")}>Usuário de App</div>
                    <div onClick={() => handleUserRoleSelect("Usuário de Painel")}>Usuário de Painel</div>
                  </div>
                )}
              </div>
            </label>
            {
              selectedUser?.role !== "MASTER" ? (
              <label>
              <span>Loja</span>
              <div className={styles.dropdown}>
                { renderStoresDropdown() }
                { isStoreDropdownOpen && role !== "MANAGER" ? (
                  <div className={styles.dropdownContent}>
                    {stores.map((store) => (
                      <div key={store.id} onClick={() => handleSelectStore( store )}>
                        {store.name}
                      </div>
                    ))}
                  </div>
                ) : null}

                { isStoreDropdownOpen && role === "MANAGER" ? (
                  <div className={styles.dropdownContent}>
                    {stores.map((store) => (
                      <div key={store.id} className={styles.storeItem}>
                        <div className={styles.checkboxLabel}>
                          <input
                            type="checkbox"
                            checked={ selectedStores.some((s) => s.id === store.id) }
                            onChange={() => handleToggleStoreSelection( store )}
                          />
                        </div>

                        <span>{store.name}</span>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            </label>
          ) : null } 
          </form>
        </div>

        <div className={styles.buttonContent}>
          <button className={styles.buttonConfirm} onClick={ handleEditUser }>Editar Usuário</button>
          <button onClick={closeModal} className={styles.buttonCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
